import React from "react";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-md navbar-dark bg-dark" style={{ backgroundColor: "#312d2a !important" }}>
      <div className="container">
        {/* <a href="/" className="navbar-brand">
          MENU
        </a> */}
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarCollapse"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarCollapse">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item">
              <a href="/" className="nav-link active">
                Home
              </a>
            </li>
            <li className="nav-item dropdown">
              <a href="/" className="nav-link dropdown-toggle" data-toggle="dropdown">
                Account
              </a>
              <div className="dropdown-menu">
                <a href="/signup" className="dropdown-item">
                  Signup
                </a>
                <a href="/login" className="dropdown-item">
                  Login
                </a>
              </div>
            </li>
            <li className="nav-item">
              <a href="/about-us" className="nav-link">
                About US
              </a>
            </li>
            <li className="nav-item">
              <a href="/contact" className="nav-link">
                Contact Us
              </a>
            </li>
          </ul>
          {/* <div className="social ml-auto">
            <a href="/">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="/">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="/">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="/">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="/">
              <i className="fab fa-youtube"></i>
            </a>
          </div> */}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
